import * as React from 'react';
import cn from 'classnames';
import * as styles from './styles.css';

import { InlineText1, InlineText2 } from '@cian/ui-kit/typography';

import { NotDesktop, Desktop } from '../../Responsive';
import { EDealType } from '../../../types/share';

export interface IDealTypeProps {
  currentDealType: EDealType;
  onChange(dealType: EDealType): void;
}

export function DealType({ currentDealType, onChange }: IDealTypeProps) {
  const handleClick = React.useCallback(
    (value: EDealType) => {
      onChange(value);
    },
    [onChange],
  );

  return (
    <div className={styles['container']}>
      <button
        type="button"
        onClick={() => handleClick(EDealType.Sale)}
        className={cn(styles['button'], currentDealType === EDealType.Sale && styles['active'])}
      >
        <NotDesktop>
          <InlineText1>Продажа</InlineText1>
        </NotDesktop>
        <Desktop>
          <InlineText2>Продажа</InlineText2>
        </Desktop>
      </button>
      <button
        type="button"
        onClick={() => handleClick(EDealType.Rent)}
        className={cn(styles['button'], currentDealType === EDealType.Rent && styles['active'])}
      >
        <NotDesktop>
          <InlineText1>Аренда</InlineText1>
        </NotDesktop>
        <Desktop>
          <InlineText2>Аренда</InlineText2>
        </Desktop>
      </button>
    </div>
  );
}
